import { fetcher } from '@commenda/utils';

import { TUpdateBillingQuoteLinePricing } from './types';

export const updateBillingQuoteLinePricing = async (
  quoteId: string,
  lineId: string,
  params: TUpdateBillingQuoteLinePricing
): Promise<Response> =>
  fetcher(`commenda-billing/quotes/${quoteId}/lines/${lineId}/pricing`, {
    method: 'PATCH',
    body: params,
  });
